import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-3">
              热播榜单
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              大家都在看的热门影视排行
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
              {rankingItems.map((item, idx) => (
                <div
                  key={item.rank}
                  className={`flex items-center gap-4 px-5 py-4 ${
                    idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
                  } hover:bg-background-50 transition-colors cursor-pointer`}
                >
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-black ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}>
                    {item.rank}
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-bold text-foreground-800 truncate">{item.title}</span>
                      <span className="text-xs text-foreground-500 whitespace-nowrap">{item.type}</span>
                      <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-xs font-bold rounded whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
                    {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                    {item.trend === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                    {item.trend === 'same' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
                    <span>{item.hot.toLocaleString()} 热度</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}